import { useParams } from "react-router-dom";
import { AddNewPackageForm, AddNewPackageHeader } from "./components";
import { usePackage } from "@hooks/procurements/package/usePackage";

export default function AddNewPackage() {
  const { id, id2 } = useParams();
  const { packageState } = usePackage();
  const { getSingleData } = packageState;

  return (
    <div className="p-10 d-grid">
      <AddNewPackageHeader data={id ? getSingleData : null} />
      <AddNewPackageForm
        appId={id as string}
        packageId={id2 as string}
        packageData={id ? getSingleData : null}
      />
    </div>
  );
}
